/* eslint-disable no-unused-expressions */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Money from '@material-ui/icons/AttachMoney';
import Cart from '@material-ui/icons/ShoppingCart';
import Libros from '@material-ui/icons/ViewList';
import Reportes from '@material-ui/icons/PieChart';
import Tareas from '@material-ui/icons/Sync';
import Administracion from '@material-ui/icons/Settings';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faKey, faList, faBolt, faBuilding, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "react-oidc-context";
import Badge from '@material-ui/core/Badge';
import { TareasContext } from 'App/Tareas/store';
import { LayoutContext } from 'App/Layout/store';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const drawerWidth = 250;

const styles = theme => ({
  fullList: {
    width: 'auto',
  },
  nuevoPadding: {
    paddingTop: '8px',
    paddingBottom: '8px'
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    backgroundColor: '#363636',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

function Sidebar(props) {
  const { classes } = props;
  const [showAdministracionSub, toggleAdmininistradorSub] = useState(false);
  const auth = useAuth();
  const tareasContext = useContext(TareasContext);
  const layoutContext = useContext(LayoutContext);

  function changeAdministradorSub() {
    toggleAdmininistradorSub(!showAdministracionSub);
  }

  var esAdmin = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre.startsWith("Administracion") && p.BLectura+p.BEscritura)

  const sideList = (
    <div >
      {auth.isAuthenticated ?
      <div>
      <Divider />
      <List>
      {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Emitidos" && p.BLectura) &&
        <ListItem className={classes.nuevoPadding} key="Emitidos" component={Link} to="/Emitidos" button>
          <ListItemIcon>
            {layoutContext.state.nuevoDte.emitidos?<Badge color="secondary" badgeContent={layoutContext.state.nuevoDte.emitidos}><Money /></Badge>:<Money />}
          </ListItemIcon>
          <ListItemText primary="Emitidos" />
        </ListItem>}
        {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Recibidos" && p.BLectura) &&
        <ListItem className={classes.nuevoPadding} key="Recibidos" component={Link} to="/Recibidos" button>
          <ListItemIcon>
          {layoutContext.state.nuevoDte.recibidos?<Badge color="secondary" badgeContent={layoutContext.state.nuevoDte.recibidos}><Cart /></Badge>:<Cart />}
          </ListItemIcon>
          <ListItemText primary="Recibidos" />
        </ListItem>
        }
        {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Libros" && p.BLectura) &&
        <ListItem className={classes.nuevoPadding} key="Libros Contables" component={Link} to="/Libros" button>
          <ListItemIcon><Libros /></ListItemIcon>
          <ListItemText primary="Libros Contables" />
        </ListItem>}
      </List>
      <Divider />
        {/*['Reportes', 'Administración'].map((text, index) => (
          <ListItem className={classes.nuevoPadding} key={text} onClick={() => {
            props.changeTitle(text);
          }}>
            <ListItemIcon>{index % 2 === 0 ? <Reportes /> : <Administracion />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))*/}
        {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Tareas" && p.BLectura) &&
          <ListItem className={classes.nuevoPadding} key="Tareas" component={Link} to="/Tareas" button>
            <ListItemIcon>
            {tareasContext.state.tareasCorriendo && tareasContext.state.tareasCorriendo.length ?<Badge color="secondary" badgeContent={tareasContext.state.tareasCorriendo.length}><Tareas /></Badge>:<Tareas />}
            </ListItemIcon>
          <ListItemText primary="Tareas" />
        </ListItem>
        }
        {/* <ListItem className={classes.nuevoPadding} button onClick={() => {}}>
            <ListItemIcon><Reportes /></ListItemIcon>
            <ListItemText primary={"Reportes"} />
        </ListItem> */}
        {esAdmin &&
      <List>
        <ListItem className={classes.nuevoPadding} button onClick={() => {
            //props.changeTitle(text);
            changeAdministradorSub();
          }}>
            <ListItemIcon><Administracion /></ListItemIcon>
            <ListItemText primary={"Administracion"} />
        </ListItem>
        <Collapse in={showAdministracionSub} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
          {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Correo" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Correo">
              <ListItemIcon>
                <Icon>email</Icon>
              </ListItemIcon>
              <ListItemText inset primary="Correos" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Folios" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Folios">
              <ListItemIcon>
                <Icon style={{lineHeight:0.5, textAlign:"center", fontWeight: "bold"}}>#</Icon>
              </ListItemIcon>
              <ListItemText inset primary="Folios" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Certificados" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Certificados">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faIdCard} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Certificados" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Api Keys" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/ApiKeys">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faKey} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Api Keys" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Reglas" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Reglas">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faBolt} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Reglas" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Mis Clientes" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/MisClientes">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faBuilding} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Mis Clientes" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Administracion/Usuarios" && p.BLectura+p.BEscritura) &&
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Usuarios">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faUserFriends} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Usuarios" />
            </ListItem>}
            {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Admin)?
            <ListItem className={classes.nuevoPadding} button className={classes.nested} component={Link} to="/Administracion/Plantillas">
              <ListItemIcon>
                <span style={{marginLeft:"5px"}}><FontAwesomeIcon icon={faList} /></span>
              </ListItemIcon>
              <ListItemText inset primary="Plantillas" />
            </ListItem>
            :null}
          </List>
        </Collapse>
      </List>
      }
      </div>
      :null}
      
    </div>
  );

  return (
    <MuiThemeProvider theme={()=>createMuiTheme({
      overrides:{
        MuiListItemIcon:{
          root:{
            color:"#ffffff"
          }
        },
        MuiTypography:{
          subheading:{
            color:"#ffffff"
          }
        },
        MuiIconButton:{
          root:{
            color:"#EEC131"
          }
        }
      }})}>
    <Drawer variant="permanent"
      classes={{
        paper: classNames(classes.drawerPaper, !props.showSidebar && classes.drawerPaperClose),
      }}
      open={props.showSidebar}>
      <div className={classes.toolbarIcon}>
        <IconButton onClick={() => { props.toggleSidebar() }}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      {sideList}
      {/* </div> */}
    </Drawer>
    </MuiThemeProvider>
  );
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(Sidebar));